// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cf5f063d","171":"f055b580"}[chunkId] + ".chunk.js";
};